import { QBox, QFormControl, QHeading, useCurrentUser } from '@qualio/ui-components';
import { useMemo } from 'react';
import { ContentTemplateDTO } from '../../../types';
import { sortSections } from '../../../utils/contentTemplateUtils';
import { PageOrientation, QualioContentType } from '../../shared/CKEditor/models';
import { ContentEditor } from '../../shared/ContentEditor/ContentEditor';
import { PresentationUtils } from '../../shared/CKEditor/util/PresentationUtils';
import { Editor } from 'ckeditor5';
import { DefaultContent as DefaultContentLabel } from '../../../displayStrings';

export type DefaultContentProps = {
  setTemplateDto: (event: any) => void;
  templateDto: ContentTemplateDTO;
};

const DefaultContent = ({ setTemplateDto, templateDto }: DefaultContentProps) => {
  const { companyId } = useCurrentUser();
  const defaultContentSections = useMemo(
    () =>
      templateDto.sections.map((field) => ({
        content: field.content,
        position: field.position,
        title: field.title,
        type: field.type,
        attachments: null,
        id: field.id,
      })),
    [templateDto.sections],
  );

  sortSections(defaultContentSections);

  const defaultContent = {
    sections: defaultContentSections,
    content_type: QualioContentType.Template,
    orientation: PageOrientation.Portrait,
    id: null,
  };

  const handleAutoSave = async (editor: Editor) => {
    let sectionContentUpdated = false;

    const editorSections = PresentationUtils.splitEditorTextIntoSections(editor.getData(), defaultContent);
    editorSections.reverse();

    defaultContent.sections.forEach((section) => {
      const editorSectionText = editorSections.pop()?.sectionText;
      if (editorSectionText !== undefined && section.content !== editorSectionText && section.type !== 'resolution') {
        section.content = editorSectionText;
        sectionContentUpdated = true;
      }
    });
    if (sectionContentUpdated) {
      setTemplateDto({ ...templateDto, sections: defaultContent.sections });
    }
  };

  return (
    <QBox className="stepper-content" pl="2" pr="2">
      <QBox pb={5}>
        <QHeading size="md">{DefaultContentLabel}</QHeading>
      </QBox>
      <QFormControl>
        <ContentEditor
          sectionedData={defaultContent}
          companyId={companyId}
          handleAutoSave={handleAutoSave}
          allowSectionsAnchored={true}
        />
      </QFormControl>
    </QBox>
  );
};

export default DefaultContent;
